import { db } from "./firebase";

export const createLead = (newLead) =>
  db.collection("leads").add({
    created: new Date().toString(),
    ...newLead,
  });

export const getLeads = () => db.collection("leads").get();
